module.exports = __webpack_public_path__ + "media/images/benefits-banner-5e97f7f4c4dff62d5222e11139e6744a.webp";